import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import axios from 'axios';
import klaviyo from '../assets/images/integrations/klaviyo-logo.png';
import judgeMe from '../assets/images/integrations/judge-me-logo.png';
import shopify from '../assets/images/integrations/Shopify-Logo.png';
import metaLogo from '../assets/images/integrations/meta-logo.svg';
import { Link } from 'react-router-dom';

export default function Integrations() {
  const { handleSignOut, getJwtToken, canWrite } = useContext(AuthContext);
  const [integrations, setIntegrations] = useState(false);

  useEffect(() => {
    const getIntegrations = async () => {
      try {
        const token = await getJwtToken();
        const res = await axios.get('https://api.amplifyloyalty.com/app/stores/integrations',
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        if (res.data.name === 'BadRequestError') {
          handleSignOut();
        } else {
          setIntegrations(res.data);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getIntegrations();
  }, []);

  const IntegrationTile = ({ to, img, alt }) => {
    if (!canWrite) {
      return (
        <div className="integration" style={{ opacity: 0.7, cursor: 'default' }} title="Read-only access">
          <img className="integration__image" src={img} alt={alt} />
        </div>
      );
    }
    return (
      <Link to={to} className="integration">
        <img className="integration__image" src={img} alt={alt} />
      </Link>
    );
  };

  return (
    <div className="main">
      {!canWrite && (
        <p className="settings__sub-heading" style={{ marginBottom: '1rem', padding: '0 1rem' }}>
          You have read-only access. Integration settings cannot be changed.
        </p>
      )}
      <section className="integrations-wrapper centralize">
        <div className="integrations__heading">E-Commerce</div>
        <div className="integrations">
          <IntegrationTile to="/app/integrations/shopify" img={shopify} alt="Shopify Logo" />
        </div>
      </section>
      <section className="integrations-wrapper centralize">
        <div className="integrations__heading">Email/SMS</div>
        <div className="integrations">
          <IntegrationTile to="/app/integrations/klaviyo" img={klaviyo} alt="Klaviyo Logo" />
        </div>
      </section>
      <section className="integrations-wrapper centralize">
        <div className="integrations__heading">Reviews</div>
        <div className="integrations">
          <IntegrationTile to="/app/integrations/judgeme" img={judgeMe} alt="JudgeMe Logo" />
        </div>
      </section>
      <section className="integrations-wrapper centralize">
        <div className="integrations__heading">Advertising</div>
        <div className="integrations">
          <IntegrationTile to="/app/integrations/meta-ads" img={metaLogo} alt="Meta Ads Logo" />
        </div>
      </section>
    </div>
  );
}
